export default __webpack_public_path__ + "static/media/statement.814ac97b.png";